import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRange", "onDatesChange", "startDate", "endDate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { START_DATE, useDatepicker } from '@datepicker-react/hooks';
import { isBefore } from 'date-fns';
var warning = require('warning');
import { isDefined, safeInvoke } from '../../../library';
import { DatePickerContext } from './context';
import { Month } from './month';
import { isNull } from 'lodash-es';
export var datePickerClasses = {
  DATE_PICKER: 'date-picker',
  MONTH: 'date-picker__month',
  MONTH_LABEL: 'date-picker__month-label',
  MONTH_HEADER: 'date-picker__month-header',
  DAY: 'date-picker__day'
};
export var DatePicker = function DatePicker(props) {
  var isRange = props.isRange,
    onDatesChange = props.onDatesChange,
    startDate = props.startDate,
    endDate = props.endDate,
    datePickerProps = _objectWithoutProperties(props, _excluded);
  var isInvalidRange = isDefined(startDate) && isDefined(endDate) && isBefore(endDate, startDate) || isNull(startDate) && isDefined(endDate);
  warning(!isInvalidRange, 'Date Range is Invalid. Make sure `endDate` is after `startDate`.');
  var handleDatesChange = function handleDatesChange(data) {
    if (props.isRange) {
      safeInvoke(props.onDatesChange, _objectSpread({}, data));
    } else {
      safeInvoke(props.onDatesChange, _objectSpread(_objectSpread({}, data), {}, {
        endDate: null,
        focusedInput: START_DATE
      }));
    }
  };
  var _useDatepicker = useDatepicker(_objectSpread(_objectSpread({}, datePickerProps), {}, {
      startDate: isInvalidRange ? null : startDate,
      endDate: isInvalidRange ? null : endDate,
      exactMinBookingDays: !isRange,
      onDatesChange: handleDatesChange
    })),
    firstDayOfWeek = _useDatepicker.firstDayOfWeek,
    activeMonths = _useDatepicker.activeMonths,
    isDateSelected = _useDatepicker.isDateSelected,
    isDateHovered = _useDatepicker.isDateHovered,
    isDateBlocked = _useDatepicker.isDateBlocked,
    isDateFocused = _useDatepicker.isDateFocused,
    isFirstOrLastSelectedDate = _useDatepicker.isFirstOrLastSelectedDate,
    focusedDate = _useDatepicker.focusedDate,
    onDateHover = _useDatepicker.onDateHover,
    onDateSelect = _useDatepicker.onDateSelect,
    onDateFocus = _useDatepicker.onDateFocus,
    goToPreviousMonths = _useDatepicker.goToPreviousMonths,
    goToNextMonths = _useDatepicker.goToNextMonths;
  var contextProps = {
    focusedDate: focusedDate,
    isDateSelected: isDateSelected,
    isDateHovered: isDateHovered,
    isDateBlocked: isDateBlocked,
    isDateFocused: isDateFocused,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
    onDateHover: onDateHover,
    onDateSelect: onDateSelect,
    onDateFocus: onDateFocus,
    startDate: props.startDate,
    endDate: props.endDate,
    goToPreviousMonths: goToPreviousMonths,
    goToNextMonths: goToNextMonths
  };
  return React.createElement(DatePickerContext.Provider, {
    value: contextProps
  }, React.createElement("div", {
    className: datePickerClasses.DATE_PICKER,
    tabIndex: 0
  }, React.createElement("div", {
    className: "months"
  }, activeMonths.map(function (month) {
    return React.createElement(Month, {
      key: "".concat(month.year, "-").concat(month.month),
      month: month,
      firstDayOfWeek: firstDayOfWeek
    });
  }))));
};
DatePicker.defaultProps = {
  endDate: null,
  isRange: false,
  numberOfMonths: 1
};